import React, {useCallback} from 'react';

import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
import getIconByType from '../../../getIconByType';
import getTitleByType from '../../../getTitleByType';
import {getDateByCustomFormat, DATE_FORMATS} from 'utils/date';
import {IconButton, Layout, Text, TrashBinIcon, WarningIcon} from '@phonectas/unifon-ui-kit';
import EventDescription from '../EventDescription';
import {EventData} from './types';

const ThreeSixtyComments: React.FC<EventData> = ({data, id, filters}) => {
	const {
		deleteEventComment,
		getAccountFeed,
	} = useThreeSixtyNewStore((state) => ({
		deleteEventComment: state.deleteEventComment,
		getAccountFeed: state.getAccountFeed,
	}), shallow);
	const currentUser = useThreeSixtyNewStore((state) => state.currentUser);
	const commentUser = data?.data_fields?.actor?.name || data?.data_fields?.actor_name;
	const isWarning = data?.is_warning;

	const handleDelete = useCallback(() => {
		if (!id) return;
		deleteEventComment(id,
			() => {
				getAccountFeed({
					id: data.account_id,
					feedType: filters || [],
				});
			},
		);
	}, [
		id,
		data.account_id,
		deleteEventComment,
		getAccountFeed,
		filters,
	]);

	return (
		<Layout gap="sm" fullWidth nowrap fullHeight>
			<Layout direction="column" nowrap gap="md" alignItems="center" style={{width: '42px'}}>
				<Layout>
					{getIconByType(data?.feed_type)}
				</Layout>
				<Layout>
					{
						isWarning && (
							<Layout>
								<WarningIcon color="warning" />
							</Layout>
						)
					}
				</Layout>
			</Layout>
			<Layout direction="column" fullWidth nowrap>
				<Layout direction="row" fullWidth nowrap>
					<Layout direction="column" fullWidth nowrap gap="xs">
						<Layout direction="row" fullWidth alignItems="center" gap="none" justifyContent="space-between">
							<Text variant="h3">{getTitleByType(data?.feed_type)}</Text>
							<Text color="textSecondary" variant="body1">
								{
									getDateByCustomFormat(data?.created_at, DATE_FORMATS.DD_MM_YY_HH_mm)
								}
							</Text>
						</Layout>
						<Layout fullWidth direction="row" nowrap>
							<Layout fullWidth gap="none">
								<Layout
									direction="row"
									justifyContent="space-between"
									fullWidth
									alignItems="center"
									gap="none"
								>
									<Text color="textSecondary" style={{alignItems: 'center'}} variant="body1">
										{data?.data_fields?.actor?.name ? data?.data_fields.actor?.name : data.data_fields?.actor_name}
									</Text>
									<IconButton
										size="sm"
										color="error"
										onClick={handleDelete}
										disabled={currentUser !== commentUser}
										compact
									>
										<TrashBinIcon />
									</IconButton>
								</Layout>
								<Layout
									direction="row"
									fullWidth
									justifyContent="space-between"
									gap="none"
									alignItems="center"
									nowrap
								>
									<Text color="textSecondary" variant="body1">
										{data?.data_fields.user_name}
									</Text>
								</Layout>
							</Layout>
						</Layout>
						<Layout direction="row" nowrap>
							<EventDescription description={data?.data_fields.body} />
						</Layout>
						<Layout direction="row" fullWidth style={{gap: '8px'}}>
						</Layout>
					</Layout>
				</Layout>
			</Layout>
		</Layout>
	);
}

export default ThreeSixtyComments;
